<!--========== View muestra curso BUSCADO ========-->

<div class="animate">

    <!--========== NEW BANNER FILTER========-->
    <section class="max-w-7xl  mx-auto py-10">
        <!-- Fondo blanco y ancho completo -->
    
            <div class="header-dashboard">
                <!-- Breadcrumb -->
                <div
                    class="text-lg md:text-xl font-semibold mb-1 flex flex-row md:flex-row md:items-center gap-2 items-center">
                    <a class="text-gray-700 flex items-center gap-1">
                        {{ 'words.search-results' | translate }}
                    </a>
                    <!-- HIDDEN oculto texto burscar nav -->

                    <span class=" text-gray-700 items-center gap-1 truncate w-1/3 md:w-2/3 lg:w-2/3">
                        <i class="fas fa-chevron-right text-xs"></i>
                        {{searchTerm}}
                    </span>
                </div>
            </div>
      
    </section>



     <section class="w-full" >
    <section class="section-content relative mx-auto max-w-7xl pb-14 lg:pb-20">

        
            <!-- BUSCAR CURSOS // CATALOGO CATALOGUE -->

            <div class="min-h-screen py-10 flex flex-col" infinite-scroll [scrollWindow]="false"
                [infiniteScrollThrottle]="500" (scrolled)="loadMore()">

                <msc-empty-state *ngIf="catalogue && catalogue?.length === 0" [title]="'empty.content.search.title'"
                    [description]="'empty.content.search.description'">
                </msc-empty-state>

                <section class="card-course-grid flex-grow w-full">
                    <!-- Cards grid -->
                    <div
                        class=" grid-catalogue grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-5 mb-8">
                        <ng-container *ngFor="let content of catalogue">
                            <div class="relative" [ngClass]="{'custom-width-card': contents.length <= 2}">
                                <content-card id="card-catalogue" [origin]="'recomendation'"
                                    [content]="content"></content-card>
                            </div>
                        </ng-container>
                    </div>
                </section>

                <div class="container__load-more col-xxs-12">
                    <msc-load-more [loading]="loading" [pagination]="pagination" (onLoad)="loadMore()"></msc-load-more>
                </div>
            </div>

        </section>
    </section>

  
    <msc-common-spinner *ngIf="searching"></msc-common-spinner>
</div>